import React from 'react';

import { FeatureGroupEntry } from '@/types/FeatureGroup';

export const FeaturesContext = React.createContext<FeatureGroupEntry[]>([]);
export default FeaturesContext;
